import { connect } from 'react-redux';
import { Logo } from "./";
import { selectCurrentEnv, selectLogo } from "../../store/common";
export var LogoRC = connect(function (state) {
  return {
    env: selectCurrentEnv(state),
    src: selectLogo(state).src,
    href: selectLogo(state).href
  };
})(Logo);
export var LogoWithoutHrefRC = connect(function (state) {
  return {
    env: selectCurrentEnv(state),
    src: selectLogo(state).src,
    href: ''
  };
})(Logo);